import gql from 'graphql-tag';

const QUERY_HOMECARDS = gql`
  query Homecards($ids: [Int], $locale: String = "en") {
    homecards(homecardIds: $ids, locale: $locale) {
      id
      title
      type
      description
      thingsWeLike
      thingsToKeepInMind
      photoUrls {
        homecardHidpi
        homecard
      }
      checked
      reviews {
        ratingAverage
      }
      url
      monthlyPrice {
        type
        minimumPrice
        fixedPrice
      }
      currencyIsoCode
    }
  }
`;

const getHomecardsQuery = client => (ids, locale) =>
  client.query({
    query: QUERY_HOMECARDS,
    variables: { ids, locale },
    fetchPolicy: 'network-only'
  });

export default getHomecardsQuery;
